export default {
	styleOverrides: {
		root: ({ theme }) => ({
			'.MuiTableHead-root': {
				'& .MuiTableRow-root': {
					backgroundColor: theme.palette.primary.dark,
				},
				'.MuiTableCell-head': {
					color: theme.palette.primary.contrastText,
				},
			},
			'.MuiTableBody-root': {
				'.MuiTableRow-root': {
					'&:hover': {
						backgroundColor: 'rgba(41, 86, 158, 0.08)',
					},
					'&:nth-of-type(odd)': {
						backgroundColor: theme.palette.background.eveCustom.secondary,
						'&:hover': {
							backgroundColor: 'rgba(41, 86, 158, 0.08)',
						},
					},
				},
			},
		}),
	},
};
